import { RateSource } from '@/modules/common/types/rate-source';

import { ProjectTeamMember } from '../../types/project-team-member';

/**
 * Gets the rate value for a team member based on their active rate source
 * This is the single source of truth for extracting rate values from team members
 */
export const getMemberRateBySource = (member: ProjectTeamMember): number => {
  switch (member.activeRateSource) {
    case RateSource.UserExternalRate:
      return member.userExternalRateValue ?? 0;
    case RateSource.SeniorityBasedRate:
      return member.seniorityBasedRateValue ?? 0;
    case RateSource.RoleBasedRate:
      return member.roleBasedRateValue ?? 0;
    case RateSource.GlobalDefaultRate:
      return member.globalDefaultRateValue ?? 0;
    case RateSource.ProjectRateCard:
      return member.projectRateCardValue ?? 0;
    case RateSource.FlatRate:
    case RateSource.Custom:
      return member.customRateValue ?? 0;
    default:
      return member.customRateValue ?? member.userExternalRateValue ?? 0;
  }
};

/**
 * Extracts currency code from various formats (string or Currency object)
 */
export const extractCurrencyCode = (value: unknown): string | null => {
  if (!value) return null;
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null && 'code' in value) {
    return (value as { code: string }).code;
  }
  return null;
};
